(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculator"]) return;
  try {
    
// keyup touchend
//$('#cost-calculator input, #cost-calculator select').on('keyup touchend', function() {
$('#cost-calculator input, #cost-calculator select').on('change keyup', function() {
  calculate();
});

$('#cost-calculator form').on('submit', function(e) {
  e.preventDefault();
  calculate();
});

var rangeSlider = function(){
  var slider = $('label'),
      range = $('.range-slider'),
      value = $('.range-slider__value > span');
    
  slider.each(function(){

    value.each(function(){
      var value = $(this).parents('label').find('.range-slider').attr('value');
      $(this).html(value);
    });

    range.on('input', function(){
      if ($(this).siblings('.range-slider__value').find('input').length) {
        $(this).siblings('.range-slider__value').find('input').val(this.value);
      } else {
        $(this).siblings('.range-slider__value').find('span').html(this.value);
      }
    });
  });
};

rangeSlider();

function calculate() {
  var cost = $('#manual-cost').val();
  var years = $('#calculator-years').val();
  var use = $('#calculator-use').val();
  var useFreq = $('#calculator-use-freq').val();

  if (!cost || !years || !use) {
    $('#total').text('');
    return;
  }
  
  var totalUse = parseInt(use) * parseInt(useFreq) * parseInt(years);
  var costPerUse = (parseFloat(cost) / totalUse).toFixed(2);
  
  $('#total').html('Your product will cost <span>£' + costPerUse + "&nbsp;per&nbsp;use</span>");
};

$('#manual-cost').on('change input', function() {
  var manualValue = parseInt($(this).val());
  $(this).parents('label').find('#calculator-cost').val(manualValue);
});


  } catch(e) { console.error(e); }
})();
})();
